export default __webpack_public_path__ + "locales/lo-LA/Common.json?hash=78acd79065cbdc55ac3e9bd6f96da3ee";